window.PerfilPage={
    data: {
        isEmailValid : false,
        email: "",
        formHandler: null
    },
    get: function (ev) {
        return eval("PerfilPage.data."+ev);
    },
    watch: {
        required: ($refField,$refSpan) => {
            if(!FormGenericValidator.required($refField.val())){
                BSForm.error($refField,$refSpan,"Este campo deve ser preenchido");
                return false;

            }
            else return true;
        },
        email: (val) => {
            return new Promise(resolve => {

                $("#formAtualizaCadastroUsuario #email").val(val.toLowerCase());
                if (PerfilPage.watch.required($('#email'), $('#spanEmailErro'))) {
                    if (FormGenericValidator.email(val)) {
                        if (val != PerfilPage.get('email')) {
                            $('#emailSpinner').css({display: "inline-block"});
                            FormGenericValidator.emailExists(val,urls.validate_email,'update').then((isValid) => {
                                $('#emailSpinner').hide();
                                if (isValid) {
                                    BSForm.success($("#email"),$("#spanEmailErro"));
                                }
                                else {
                                    BSForm.error($("#email"),$("#spanEmailErro"),"E-mail já cadastrado na Benfeitoria");
                                }
                                PerfilPage.data.email=val;
                                PerfilPage.data.isEmailValid=isValid;

                                resolve(true);
                            });
                        }else resolve(PerfilPage.get('isEmailValid'));
                    }
                    else {
                        BSForm.error($("#email"), $("#spanEmailErro"), "E-mail inválido");
                        resolve(false);
                    }
                }
                else resolve(false);
            });
        },
        birthday: (date) => {
            if(!PerfilPage.watch.required($('#nascimento'),$('#spanNascimentoErro'))) return false;
            else{
                if(FormGenericValidator.birthday(date)){
                    let date_formated=Utils.formatDate(date.toString());
                    if(FormGenericValidator.dateValid(date_formated)) {
                        if (
                            FormGenericValidator
                                .dateGreater(
                                    date_formated,
                                    Utils.formatDate(current_date)
                                ) == 1
                            ) {
                            BSForm.error($("#nascimento"), $("#spanNascimentoErro"), "Preencha com uma data anterior a data atual");
                        }
                        else {
                            BSForm.success($("#nascimento"), $("#spanNascimentoErro"));
                            return true;
                        }
                    }else {
                        BSForm.error($("#nascimento"), $("#spanNascimentoErro"), "Preencha com uma data válida");
                    }
                    return false;
                }else{
                    BSForm.error($("#nascimento"),$("#spanNascimentoErro"),"Digite o seu nascimento no formato DD/MM/YYYY");
                    return false;
                }
            }
        },
        name: (val) => {
            if(!PerfilPage.watch.required($('#nome'),$('#spanNomeErro'))) return false;
            else{
                if(val.toString().trim().length<3){
                    BSForm.error($('#nome'),$('#spanNomeErro'),'O nome deve conter ao menos 3 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#nome'),$('#spanNomeErro'));
                    return true;
                }
            }
        },
        companyName: (val) => {
            if(!PerfilPage.watch.required($('#inputCompanyName'),$('#spanCompanyNAmeErro'))) return false;
            else{
                if(val.toString().trim().length<3){
                    BSForm.error($('#inputCompanyName'),$('#spanCompanyNAmeErro'),'O nomeda empresa deve conter ao menos 3 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#inputCompanyName'),$('#spanCompanyNAmeErro'));
                    return true;
                }
            }
        },
        password: (password) => {
            if(!PerfilPage.watch.required($('#inputSenha1'),$('#spanSenhaErro'))) return false;
            else if(FormGenericValidator.password(password)){
                if($('#inputSenha1').val().length>0) {
                    if (FormGenericValidator.passwordConfirm($("#inputSenha1").val(), $("#inputSenha2").val()))
                        BSForm.success($("#csenha"), $('#spanSenhaConfirmaErro'));
                    else
                        BSForm.error(
                            $("#inputSenha2"),
                            $('#spanSenhaConfirmaErro'),
                            "A confirmação deve ser igual a senha digitada anteriormente"
                        );
                }
                BSForm.success($("#inputSenha1"),$('#spanSenhaErro'));
                return true;
            }else{
                BSForm.error($("#inputSenha1"),$('#spanSenhaErro'),"A senha deve conter no mínimo 6 caractéres");
                return false;
            }
        },
        passwordConfirm: (password,password_confirmation) => {
            if(!PerfilPage.watch.required($('#inputSenha2'),$('#spanSenhaConfirmaErro'))) return false;
            else if(FormGenericValidator.passwordConfirm(password,password_confirmation)){
                BSForm.success($("#inputSenha2"),$('#spanSenhaConfirmaErro'));
                return true;
            }else{
                BSForm.error($("#inputSenha2"),$('#spanSenhaConfirmaErro'),"A confirmação deve ser igual a senha digitada anteriormente");
                return false;
            }
        },
        country: (val,CHECK_ONLY) => {

            let brAddress = $("#stateSelectWrapper,#citySelectWrapper");
            let notBrAddress = $('#stateInputWrapper,#cityInputWrapper');
            let brBlock = $('#blocoBrasil');
            let cepBlock = $('.input-cep-container');
            let phoneBlock = $('#inputTelefoneResidencial,#labelTelefone');
            let cpfBlock = $('#cpfBlock');
            let cnpjBlock = $('#cnpjBlock');

            if(PerfilPage.watch.required($("#pais"),$("#spanCountryErro"))){
                $("#countrySpinner").css({
                    display: "inline-block"
                });
                BSForm.success($('#pais'),$('#spanCountryErro'));
                if(typeof CHECK_ONLY === "undefined") {


                    if ($("#pais").val() == 5) {
                    $.ajax({
                        url: urls.load_states,
                        method: "GET",
                        async: false,
                        success: (data) => {
                            $("#estado").html(data);
                            $("#stateSelectWrapper").show();
                            brBlock.show();
                            cepBlock.show();
                            notBrAddress.hide();
                            phoneBlock.show();
                            cpfBlock.show();
                            cnpjBlock.show();
                        },
                        error: (e) => {
                            alert("ERRO AO CARREGAR ESTADOS");
                            console.log(e);
                        }
                    });
                } else {
                    brAddress.hide();
                    brBlock.hide();
                    cepBlock.hide();
                    notBrAddress.show();
                    phoneBlock.hide();
                    cpfBlock.hide();
                    cnpjBlock.hide();
                }

                }
                $("#countrySpinner").hide();
                return true;
            }
            else {
                $("#stateSelectWrapper,#stateInputWrapper,#citySelectWrapper,#cityInputWrapper").hide();
                return false;
            }
        },
        state: function (type,CHECK_ONLY) {
            if(type=="select"){
                if(PerfilPage.watch.required($("#estado"),$("#spanStateErro"))){
                    BSForm.success($("#estado"),$('#spanStateErro'));
                    $('#stateSpinner').css({display: "inline-block"});
                    if(typeof CHECK_ONLY == "undefined") {
                        $.ajax({
                            url: urls.load_cities + "/" + $("#estado").val(),
                            method: "GET",
                            async: false,
                            success: (data) => {
                                $("#cidade").html(data);
                                $('#citySelectWrapper').show();
                            },
                            error: (e) => {
                                alert("ERRO AO CARREGAR CIDADES");
                                console.log(e);
                            }
                        });
                    }
                    $('#stateSpinner').hide();
                    return true;
                }else {
                    $('#citySelectWrapper').hide();
                    return false;
                }
            }
            else if(type == "input"){
                if(PerfilPage.watch.required($("#inputNomeEstado"),$("#spanNewStateErro"))){
                    BSForm.success($("#inputNomeEstado"),$("#spanNewStateErro"));
                    return true
                }
                else return false;
            }
            else return false;
        },
        city: function (type) {
            if(type=="select"){
                if(PerfilPage.watch.required($("#cidade"),$("#spanCityErro"))){
                    BSForm.success($("#cidade"),$("#spanCityErro"));
                    return true;
                }else return false;
            }
            else if(type == "input"){
                if(PerfilPage.watch.required($("#inputNomeCidade"),$("#spanNewCityErro"))){
                    BSForm.success($("#inputNomeCidade"),$('#spanNewCityErro'));
                    return true
                }
                else return false;
            }
            else return false;
        },
        street: (val) => {
            if(!PerfilPage.watch.required($('#inputEnderecoRua'),$('#spanRuaErro'))) return false;
            else{
                if(val.toString().trim().length<5){
                    BSForm.error($('#inputEnderecoRua'),$('#spanRuaErro'),'O endereço deve conter ao menos 5 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#inputEnderecoRua'),$('#spanRuaErro'));
                    return true;
                }
            }
        },
        number: (val) => {
            if(!PerfilPage.watch.required($('#inputEnderecoNumero'),$('#spanNumberErro'))) return false;
            else

                    BSForm.success($('#inputEnderecoNumero'),$('#spanNumberErro'));
                    return true;


        },
        neighborhood: (val) => {
            if(!PerfilPage.watch.required($('#inputEnderecoBairro'),$('#spanBairroErro'))) return false;
            else{
                if(val.toString().trim().length<3){
                    BSForm.error($('#inputEnderecoBairro'),$('#spanBairroErro'),'O bairro deve conter ao menos 3 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#inputEnderecoBairro'),$('#spanBairroErro'));
                    return true;
                }
            }
        },
        zip: (val) => {
            if(!PerfilPage.watch.required($('#inputCEP'),$('#spanCepErro'))) return false;
            else{
                if(val.toString().trim().length<9){
                    BSForm.error($('#inputCEP'),$('#spanCepErro'),'O cep deve conter ao menos 9 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#inputCEP'),$('#spanCepErro'));
                    return true;
                }
            }
        },
        phone: (val) => {
            if(!PerfilPage.watch.required($('#inputTelefoneResidencial'),$('#spanTelefoneResidencialErro'))) return false;
            else{
                if(val.toString().trim().length<14){
                    BSForm.error($('#inputTelefoneResidencial'),$('#spanTelefoneResidencialErro'),'O telefone deve conter ao menos 10 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#inputTelefoneResidencial'),$('#spanTelefoneResidencialErro'));
                    return true;
                }
            }
        },
        ccIN: (val) => {
            if (PerfilPage.watch.required($('#bandeira'), $('#spanBandeiraErro'))) {
                BSForm.success($("#bandeira"), $('#spanBandeiraErro'));
                return true;
            } else return false;
        },
        ccNumber: (bandeira,val) => {
            val = val.replace(/ /g,"");
            if (!PerfilPage.watch.required($('#cc_numero'), $('#spanCCNumeroErro'))) return false;
            else {
                let cardL = bandeira == "amex" ? 15 : 16;
                if (val.toString().trim().length < cardL) {
                    BSForm.error($('#cc_numero'), $('#spanCCNumeroErro'), `O número do cartão deve conter ao menos ${cardL} caractéres.`);
                    return false;
                }
                else {
                    BSForm.success($('#cc_numero'), $('#spanCCNumeroErro'));
                    return true;
                }
            }
        },
        ccName: (val) => {
            if (!PerfilPage.watch.required($('#cc_nome_impresso'), $('#spanCCNomeImpresso'))) return false;
            else {
                if (val.toString().trim().length < 5) {
                    BSForm.error($('#cc_nome_impresso'), $('#spanCCNomeImpresso'), 'O nome deve conter ao menos 5 caractéres.');
                    return false;
                }
                else {
                    BSForm.success($('#cc_nome_impresso'), $('#spanCCNomeImpresso'));
                    return true;
                }
            }
        },
        ccGT: (val) => {


            if (!PerfilPage.watch.required($('#cc_validade'), $('#spanCCValidade'))) return false;
            else {
                if (val.toString().trim().length < 7) {
                    BSForm.error($('#cc_validade'), $('#spanCCValidade'), 'A validade deve conter ao menos 6 caractéres.');
                    return false;
                }
                else {
                    BSForm.success($('#cc_validade'), $('#spanCCValidade'));
                    return true;
                }
            }
        },

        cCVV: (val) => {
            //
            if (!PerfilPage.watch.required($('#cc_codigo_seguranca'), $('#spancc_codigo_seguranca'))) return false;
            else {
                if (val.toString().trim().length < 3) {
                    BSForm.error($('#cc_codigo_seguranca'), $('#spancc_codigo_seguranca'), 'O código de segurança deve conter ao menos 3 caractéres.');
                    return false;
                }
                else {
                    BSForm.success($('#cc_codigo_seguranca'), $('#spancc_codigo_seguranca'));
                    return true;
                }
            }
        },

        picture: (element) => {

            var options = {
                thumbBox: '.thumbBox',
                spinner: '.spinner'
            };

            $("#btnCrop").click(function () {
                // $(".conclude").removeClass("hide");
                var img = cropper.getDataURL();
                $('.cropped').html('').append('<img src="' + img + '">');
                $('#image_data').val(img);
                $('#btnConcluirCorte').prop('disabled', false);
                $(".conclude").fadeIn();
            });

            if ($('.imageBox').length) {
                var cropper = $('.imageBox').cropbox(options);
            }

            var input = $('#file');

            let reader = new FileReader();
            reader.onload = function (e) {
                options.imgSrc = e.target.result;
                cropper = $('.imageBox').cropbox(options);
            };
            reader.readAsDataURL(input[0].files[0]);

            $("#modalCrop").modal('show');

            $('#btnZoomIn').on('click', function () {
                cropper.zoomIn();
            });
            $('#btnZoomOut').on('click', function () {
                cropper.zoomOut();
            });

            if (input[0].files && input[0].files[0]) {
                reader = new FileReader();
                reader.onload = function (e) {
                    $('.cropped').html('').append($('<img width="200px">').attr('src', e.target.result));
                    $('#image_data').val(e.target.result);
                };
                reader.readAsDataURL(input[0].files[0]);
            }
        },
        cpf: () => {
            if(!PerfilPage.watch.required($('#inputCPF'),$('#spanCPFErro'))) return false;
            else{
                if(!FormGenericValidator.cpf($('#inputCPF').val())){
                    BSForm.error($('#inputCPF'),$('#spanCPFErro'),'Informe um CPF válido.');
                    return false;
                }
                else{
                    BSForm.success($('#inputCPF'),$('#spanCPFErro'));
                    return true;
                }
            }
        },
        cnpj: () => {
            if(!PerfilPage.watch.required($('#inputCNPJ'),$('#spanCNPJErro'))) return false;
            else{
                if(!FormGenericValidator.cnpj($('#inputCNPJ').val())){
                    BSForm.error($('#inputCNPJ'),$('#spanCNPJErro'),'Informe um CNPJ válido.');
                    return false;
                }
                else{
                    BSForm.success($('#inputCNPJ'),$('#spanCNPJErro'));
                    return true;
                }
            }
        },
        updateCCMask(bandeira){
            if(bandeira!="amex"){
                $('#cc_codigo_seguranca').mask('000');
            }
            switch(bandeira){
                case 'visa':
                    $('#cc_numero').mask('0000 0000 0000 0000', {
                        placeholder: "Digite o número de seu cartão",
                    });
                    break;
                case "mastercard":
                    $('#cc_numero').mask('0000 0000 0000 0000', {
                        placeholder: "Digite o número de seu cartão",
                    });
                    break;
                case "amex" :
                    $('#cc_numero').mask('0000 000000 00000', {
                        placeholder: "Digite o número de seu cartão"
                    });
                    $('#cc_codigo_seguranca').mask('0000');
                    break;
                default:
                    $("#cc_numero").mask("9999 9999 9999 9999",{
                        placeholder: "Digite o número de seu cartão"
                    })
            }
            $()
        },
        toggleCCInfo(on){
            if (on) {
                let self =this;
                this.updateCCMask($('#bandeira').val());
                $('#infoCartaoMoip, #editaCartaoMoip').toggle();
                $('#bandeira').change(function(){
                    self.updateCCMask($('#bandeira').val());
                });
            }
        },
        toggleAddress: () => {

            let brAddress = $("#stateSelectWrapper,#citySelectWrapper");
            let notBrAddress = $('#stateInputWrapper,#cityInputWrapper');
            let brBlock = $('#blocoBrasil');
            let cepBlock = $('.input-cep-container');

            if ($("#pais").val() == 5) {

                        brAddress.show();
                        cepBlock.show();
                        brBlock.show();
                        notBrAddress.hide();


            } else {
                brAddress.hide();
                brBlock.hide();
                cepBlock.hide();
                notBrAddress.show();
            }

        },
        updateCCInfo: (on) => {
            let sBandeira = $("#bandeira").val();
            let sNumeroCartao = $("#cc_numero").val();
            let sNomeImpresso = $("#cc_nome_impresso").val();
            let sValidade = $("#cc_validade").val();
            let cvv = $("#cc_codigo_seguranca").val();
            let moipMsg = $('#mensagemMoip');
            let moipContent = $('#conteudoMensagemMoip');
            let moipClass = $('#moipClass');
            let moipHeader = $('#moipHeader');
            let actionButtons = $('#atualizarcc,#mobatualizarcc');

            if (on &&
                PerfilPage.watch.ccIN(sBandeira) &&
                PerfilPage.watch.ccNumber(sBandeira,sNumeroCartao) &&
                PerfilPage.watch.ccName(sNomeImpresso) &&
                PerfilPage.watch.ccGT(sValidade) &&
                PerfilPage.watch.cCVV(cvv)
            ) {
                // console.log('valid')
                actionButtons.button('loading');

                $.ajax({
                    type: 'POST',
                    url: '/recorrente/ajax/updateCreditCard',
                    data: {
                        cc_flag: sBandeira,
                        cc_number: sNumeroCartao,
                        cc_holder_name: sNomeImpresso,
                        cc_expiration_date: sValidade
                    },
                    dataType: 'json',
                    cache: false,
                    timeout: 30000,
                    success: function (json) {
                        if (json.retorno) {
                            $('#divLoader').hide();
                            if (json.retorno === 'ok') {
                                actionButtons.button('reset');
                                // Mostra o div de sucesso
                                moipContent.html('<p>Cartão atualizado com sucesso!</p>');
                                moipMsg.show();
                                moipMsg.focus();
                            }
                            else {
                                actionButtons.button('reset');
                                moipContent.html('<h1>Atenção!</h1>' + json.mensagem_erro);
                                moipMsg.show();
                                moipMsg.focus();
                            }
                        }
                        else {
                            // não recebeu um json
                            actionButtons.button('reset');
                            moipClass.removeClass('alert-danger').addClass('alert-success');
                            moipHeader.html('Sucesso!');
                            moipContent.html('Ocorreu um problema na atualização de seu cartão. <br/>Por favor, tente novamente.');
                            moipMsg.show();
                            moipMsg.focus();
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        actionButtons.button('reset');
                        switch (textStatus) {
                            case 'timeout'    :
                                moipContent.html('TEMPO EXCEDIDO AO CONECTAR COM O GATEWAY DE PAGAMENTO. A mensagem informada foi: ' + errorThrown + '<br/>Por favor, tente novamente.');
                                moipMsg.show();
                                moipMsg.focus();
                                break;
                            default         :
                                moipContent.html('<p>OCORREU UM ERRO. A mensagem informada foi: ' + errorThrown + '<br/>Por favor, tente novamente.</p>');
                                moipMsg.show();
                                moipMsg.focus();
                                break;
                        }
                    }
                });
            }
        },

        validatesPf: (emailIsValid) => {

            if(
                emailIsValid &
                PerfilPage.watch.birthday($("#nascimento").val()) &
                PerfilPage.watch.name($("#nome").val()) &
                PerfilPage.watch.country($("#pais").val(),"CHECK_ONLY")
            ){
                $("#formAtualizaCadastroUsuario").unbind("submit",PerfilPage.data.formHandler);
                $('#formAtualizaCadastroUsuario').submit();
            }
            else{
                BSButton.dismiss($('#btnCriar,#btnCriarMobile'));
            }

        },

        validatesPj: (emailIsValid) => {
            if(
                emailIsValid &
                PerfilPage.watch.companyName($("#inputCompanyName").val()) &
                PerfilPage.watch.country($("#pais").val(),"CHECK_ONLY")
            ){
                $("#formAtualizaCadastroUsuario").unbind("submit",PerfilPage.data.formHandler);
                $('#formAtualizaCadastroUsuario').submit();
            }
            else{
                BSButton.dismiss($('#btnCriar,#btnCriarMobile'));
            }
        },

        form_send: (type) => {
            PerfilPage.watch.email($("#email").val()).then((emailIsValid) => {
                switch (type){
                    case 'pf':
                        PerfilPage.watch.validatesPf(emailIsValid);
                        break;
                    case 'pj':
                        PerfilPage.watch.validatesPj(emailIsValid);
                        break;
                }
            }).catch((e) => {
                console.log(e);
                BSButton.dismiss($('#btnCriar,#btnCriarMobile'));
            });
        }
    },
    load: function () {
        let self=this;



        //toggle address data on load

       self.watch.toggleAddress();


        //MASKS
        $('#nascimento').mask('99/99/9999');
        $('#inputCPF').mask('999.999.999-99');
        $('#inputTelefoneResidencial').mask('(99) 99999-9999');
        $('#inputCEP').mask('99999-999');
        $('#cc_numero').mask('9999999999999999');
        $('#cc_validade').mask('99/9999');
        $('#cc_codigo_seguranca').mask('9999');

        //TEXT AREA CHAR COUNT
        let profile = $("#profile");
        if (profile && profile.length) {
            profile.limit(300,'#countinputPerfilPublico')
        }



        /*
        * EVENTS LIST
         */

        //listen to modal open event and adjust its size to fit in the screen
        $('#modalCrop').on('show',function(){
            $('.modal .modal-body').css('overflow-y', 'auto');
            $('.modal .modal-body').css('max-height', $(window).height() * 0.7);
        });

        $('#formAtualizaCadastroUsuario #nome').on('blur',function(){
            self.watch.name($(this).val());
        });
        $('#formAtualizaCadastroUsuario #email').on('blur',function(){
            self.watch.email($(this).val());
        });
        $('#formAtualizaCadastroUsuario #inputSenha1').on('blur',function(){
            self.watch.password($(this).val());
        });
        $('#formAtualizaCadastroUsuario #inputSenha2').on('blur',function(){
            self.watch.passwordConfirm($("#inputSenha1").val(),$(this).val());
        });
        $('#formAtualizaCadastroUsuario #nascimento').on('blur',function () {
            self.watch.birthday($("#nascimento").val());
        });
        $('#formAtualizaCadastroUsuario #pais').on('change',function () {
            self.watch.country($("#pais").val());

        });
        $('#formAtualizaCadastroUsuario #estado').on('change',function () {
            self.watch.state("select");
        });
        $('#formAtualizaCadastroUsuario #inputNomeEstado').on('blur',function () {
            self.watch.state("input");
        });
        $('#formAtualizaCadastroUsuario #cidade').on('change',function () {
            self.watch.city("select");
        });
        $('#formAtualizaCadastroUsuario #inputNomeCidade').on('blur',function () {
            self.watch.city("input");
        });
        $('#formAtualizaCadastroUsuario #inputCPF').on('blur',function () {
            self.watch.cpf();
        });

        // PJ
        $('#formAtualizaCadastroUsuario #inputCNPJ').on('blur',function () {
            self.watch.cnpj();
        });

        $('#formAtualizaCadastroUsuario #inputCompanyName').on('blur',function(){
            self.watch.companyName($(this).val());
        });

        $('#formAtualizaCadastroUsuario #inputEnderecoRua').on('blur',function () {
            self.watch.street($("#inputEnderecoRua").val());
        });
        $('#formAtualizaCadastroUsuario #inputEnderecoNumero').on('blur',function () {
            self.watch.number($("#inputEnderecoNumero").val());
        });
        $('#formAtualizaCadastroUsuario #inputEnderecoBairro').on('blur',function () {
            self.watch.neighborhood($("#inputEnderecoBairro").val());
        });
        $('#formAtualizaCadastroUsuario #inputCEP').on('blur',function () {
            self.watch.zip($("#inputCEP").val());
        });
        $('#formAtualizaCadastroUsuario #inputTelefoneResidencial').on('blur',function () {
            self.watch.phone($("#inputTelefoneResidencial").val());
        });
        $('#file').on('change',function () {
            self.watch.picture($('input.uploadCapa'));
        });

        //CC

        $('#editcc,#mobeditcc,#canceleditcc,#mobcanceleditcc').click(() => {

            self.watch.toggleCCInfo(true);
        });

        $('#atualizarcc,#mobatualizarcc').click(() => {
            self.watch.updateCCInfo(true);
        });

        $('#cc_formAtualizaCadastroUsuario #bandeira').on('blur', function () {
            self.watch.ccIN($("#bandeira").val());
        });
        $('#cc_formAtualizaCadastroUsuario #cc_numero').on('blur', function () {
            self.watch.ccNumber($('#bandeira').val(),$("#cc_numero").val());
        });
        $('#cc_formAtualizaCadastroUsuario #cc_nome_impresso').on('blur', function () {
            self.watch.ccName($("#cc_nome_impresso").val());
        });
        $('#cc_formAtualizaCadastroUsuario #cc_validade').on('blur', function () {
            self.watch.ccGT($("#cc_validade").val());
        });
        $('#cc_formAtualizaCadastroUsuario #cc_codigo_seguranca').on('blur', function () {
            self.watch.cCVV($("#cc_codigo_seguranca").val());
        });

        if (typeof auth_refresh !== 'undefined') {
            if (auth_refresh) {
                $('#auth-refresh-modal').modal();
            }
        }


        // $('input.uploadCapa').on('click',function () {
        //     self.watch.picture($('input.uploadCapa'));
        // });
        PerfilPage.data.formHandler=function (e) {

            e.preventDefault();
            BSButton.loading($('#btnCriar,#btnCriarMobile'));
            self.watch.form_send($('#nome').length?'pf':'pj');
        };
        $("#formAtualizaCadastroUsuario").submit(PerfilPage.data.formHandler);
        /*
        * END OF EVENTS LIST
         */
    },
};
PerfilPage.load();